import USBModal, {
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@usb-shield/react-modal";
import USBButton from "@usb-shield/react-button";
import modalStore from "../store/modalStore";
import { useEffect } from "react";

const DisclosureModal = () => {
  const { isDisclosureOpen, closeDisclosure } = modalStore();

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") closeDisclosure();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [closeDisclosure]);

  if (!isDisclosureOpen) return null;

  return (
    <USBModal handleClose={closeDisclosure} id="disclosure-modal" isOpen>
      <ModalHeader id="disclosure-modal-header">
        <div className="modal-header">
          <p>Disclosure</p>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="modal-body">
          <h4 className="section-title">
            Accessibility Commitment for Elavon Data Platform
          </h4>
          <p className="text-content">
            <small>
              At Elavon, we are committed to providing accessible digital
              experiences for all customers. Our goal is to meet Web Content
              Accessibility Guidelines (WCAG) 2.2 AA standards across our
              platforms. The Data Platform has undergone accessibility testing,
              and while many features meet accessibility standards, there are
              known gaps due to technical limitations in the current development
              framework. These gaps may affect customers using assistive
              technologies. <br />
              <br />
              Known Accessibility Limitations: <br />
              <br />
              <ul>
                <li>
                  Alternative text for dynamic charts is not currently supported
                  in Power BI.
                </li>
                <li>
                  Some interactive elements may not meet minimum target size or
                  label requirements.
                </li>
              </ul>
              <br />
              We will continue to enhance accessibility conformance in upcoming
              releases, although larger issues will be resolved by migrating to
              a new platform and have a longer timeline to fix.
              <br /> <br />
              Need Assistance? If you have trouble accessing any part of the
              Data Platform, please contact us at (provide contact information).
              <br />
              <br />
              We value your feedback and are committed to continuous
              improvement.
            </small>
          </p>
          <h4 className="section-title">EU region disclosures</h4>
          <p className="text-content">
            <small>
              U.S. Bank Europe DAC. Registered in Ireland with Companies
              Registration Office. The liability of the member is limited.
              United Kingdom branch registered in England and Wales under the
              number BR022122. <br />
              <br />
              U.S. Bank Europe DAC, trading as Elavon Merchant Services, is a
              credit institution authorised and regulated by the Central Bank of
              Ireland. Authorised by the Prudential Regulation Authority.
              Subject to regulation by the Financial Conduct Authority and
              limited regulation by the Prudential Regulation Authority. Details
              about the extent of our regulation by the Prudential Regulation
              Authority are available from us on request.
              <br />
              <br />
              U.S. Bank Europe DAC. Registered in Ireland – Number 418442.
              <br />
              <br />
              Registered Office: Block F1, Cherrywood Business Park, Dublin 18,
              D18 W2X7, Ireland.
              <br />
              <br />
              U.S. Bank Europe DAC, trading as Elavon Merchant Services, is
              regulated by the Central Bank of Ireland.
              <br />
              <br />
              U.S. Bank Europe DAC, Norway Branch, org.nr 991 283 900 MVA
              Foretaksregisteret.
              <br />
              <br />
              Branch Address: Karenlyst Allé 11, 0278 Oslo; Branch postal
              address: Postboks 354 Skøyen, 0213 Oslo, Norway.
              <br />
              <br />
              Address: U.S. Bank Europe DAC, Irish registry no. 418442, Address
              Block F1, Cherrywood Business Park, Dublin 18, D18 W2X7, Ireland.
              <br />
              <br />
              U.S. Bank Europe DAC, trading as Elavon Merchant Services, is
              regulated by the Central Bank of Ireland.
            </small>
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <USBButton
          ctaStyle="standard"
          emphasis="heavy"
          onPress={closeDisclosure}
        >
          Close
        </USBButton>
      </ModalFooter>
    </USBModal>
  );
};

export default DisclosureModal;
